import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (
	baseUrl: string,
	projectKey: string,
	query: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any /* Observable<RestRunAsUserOption[]> */ => {
	const queryComponent = encodeURIComponent(query);
	return fetchJson$(
		`${baseUrl}/rest/servicedesk/1/servicedesk/sd-user-search/${projectKey}/usersWithBrowseAndEditPermissions?query=${queryComponent}`,
		{
			method: 'GET',
		},
	);
};
